import React from "react";
import {AnimatePresence, motion} from "framer-motion";
import styled from "styled-components";

const SSkipCounter = styled.div`
    position: absolute;
    color: white;
    font-size: 24px;
    top: 0;
    left: 50px;
    
    .skip-counter-row {
        background: rgb(255 255 255 / 6%);
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: 12px 10px;
        border-radius: 8px;
    }
    
    .skip-counter-text {
        font-size: 21px;
        font-weight: 200;
        opacity: 0.8;
        margin-left: 8px;
        margin-right: 20px;
    }
    
    .skip-counter-votes-block {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-right: 5px;
    }
    
    .skip-counter-votes-block > span {
        font-size: 20px;
        font-weight: 200;
        opacity: 0.8;
        margin-top: -3px;
    }
    
    .skip-counter-votes-block > div {
        width: 16px;

        padding: 8px 16px;
        text-align: center;
        display: flex;
        justify-content: center;
        font-weight: 600;
        opacity: 0.9;
        background: rgb(255 255 255 / 6%);
        border-radius: 8px;
    }
    
    .skip-counter-icon {
        height: 20px;
        display: flex;
        align-items: center;
    }
    
    .skip-counter-icon img {
        height: 50px;
        filter: invert(1);
        opacity: 0.4;
    }
    
`;

/*
.skip-counter-container {
        padding: 15px 30px;
        border-radius: 10px;
        text-align: center;

    }

    .skip-counter-header {
        font-size: 20px;
        font-size: 22px;
        font-weight: 200;
        opacity: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .skip-counter-block {
        display: flex;
        width: calc(366px - 120px);
        justify-content: center;

        margin-top: 12px;
        padding: 0px 5px;
        border-radius: 8px;
        gap: 20px;
        display: flex;
    }

    .skip-counter-block > div {
        width: 20px;

        padding: 8px 16px;
        text-align: center;
        display: flex;
        justify-content: center;
        font-weight: 600;
        opacity: 0.9;
        background: rgb(255 255 255 / 6%);
        border-radius: 8px;
    }

    .skip-left-block {

    }


<div className="skip-counter-header">
                Голосование за пропуск
            </div>
            <div className="skip-counter-block">
                <AnimatePresence mode="wait">
                    <div className="skip-left-block">
                        <motion.span
                            key={skipCurrent}
                            initial={{ opacity: 0, y: "10px" }}
                            animate={{ opacity: 1, y: "0px" }}
                            exit={{ opacity: 0, y: "-10px" }}
                            transition={{ duration: 0.2 }}
                        >
                            {skipCurrent}
                        </motion.span>

                    </div>
                </AnimatePresence>
                <div>
                    {skipTarget}
                </div>
            </div>
 */

export function SkipCounter({skipCurrent, skipTarget}) {
    return <SSkipCounter>
        <AnimatePresence>
            {!!skipCurrent && <motion.div className="skip-counter-container"
            initial={{ y: "-200px" }}
            animate={{ y: "45px" }}
            exit={{ y: "-200px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <div className="skip-counter-row">
                <div className="skip-counter-icon"><img src="/icons/skip_next_24.svg" /> </div>
                <div className="skip-counter-text">Пропуск</div>
                <div className="skip-counter-votes-block">
                    <AnimatePresence mode="wait">
                        <div className="skip-left-block">
                            <motion.span
                                key={skipCurrent}
                                initial={{ opacity: 0, y: "10px" }}
                                animate={{ opacity: 1, y: "0px" }}
                                exit={{ opacity: 0, y: "-10px" }}
                                transition={{ duration: 0.2 }}
                            >
                                {skipCurrent}
                            </motion.span>

                        </div>
                    </AnimatePresence>
                    <span>из</span>
                    <div>
                        {skipTarget}
                    </div>
                </div>
            </div>
        </motion.div>}
    </AnimatePresence>
    </SSkipCounter>
}
